export enum PersonContactEntityFilterEnum {
    SALE = 'SALE',
    OPPORTUNITY = 'OPPORTUNITY',
    PERSON_CONTACT = 'PERSON_CONTACT',
    ALL = 'ALL',
}
